/** Device and capability detection for voice capture. */

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || ('ontouchstart' in window && window.innerWidth <= 1024)
  );
};

export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

export const isStandalonePwa = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
};

export const supportsWebSpeechRecognition = (): boolean => {
  if (typeof window === 'undefined') return false;
  // iOS installed PWAs cannot use the Web Speech Recognition API.
  if (isIOS() && isStandalonePwa()) return false;
  return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
};

export const supportsMediaRecorderCapture = (): boolean => {
  if (typeof window === 'undefined') return false;
  return typeof MediaRecorder !== 'undefined' && Boolean(navigator.mediaDevices?.getUserMedia);
};

/** Use server-side transcription when browser speech recognition is unavailable. */
export const shouldUseMediaRecorderFallback = (): boolean => (
  !supportsWebSpeechRecognition() && supportsMediaRecorderCapture()
);

export const getPreferredMediaRecorderMimeType = (): string | undefined => {
  if (typeof MediaRecorder === 'undefined') return undefined;
  const types = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/aac'];
  return types.find((type) => MediaRecorder.isTypeSupported(type));
};
